export default {
  application: {
    env: 'development',
    api_url: 'http://api.local.host:8888',
    tracker_config: {baseUrl: 'http://localhost:9909', dev: true},
  },
  user: {
    identity: '8154f0e3599a97a03672c2d457ea2941',
    omnikey: 'a15d3e8835c69f1c4fd6b38fe9098b4b',
    loggedIn: true,
    session_id: '73c9ac01601efc2e461875edce491f4e',
    cart_id: 8,
    id: 1,
    id_36: '1',
    email: 'overlord@mail.com',
    username: 'overlord',
    name: 'overlord',
    chat_token: '00144a31ca05678c3a7fb44e6b396dd6',
    chat_active: true,
    chat_sound_active: true,
    is_premium: true,
    phone: '628123456789',
    is_phone_confirmed: true,
    emoney_state: 'initiated',
    gender: 'male',
    as_staff: false,
    owner_id: 1,
    staffs: null,
    owner_name: 'overlord',
    staff_id: null,
    has_staff: false,
  },
};
